import { render, staticRenderFns } from "./DecidedArticles.vue?vue&type=template&id=63ebb4ca&scoped=true&"
import script from "./DecidedArticles.vue?vue&type=script&lang=js&"
export * from "./DecidedArticles.vue?vue&type=script&lang=js&"
import style0 from "./DecidedArticles.vue?vue&type=style&index=0&id=63ebb4ca&prod&lang=css&"
import style1 from "./DecidedArticles.vue?vue&type=style&index=1&id=63ebb4ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ebb4ca",
  null
  
)

export default component.exports